import React from "react";
import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import { Search as SearchIcon, Close as ClearIcon } from "@mui/icons-material";
import FormTextField from "../FormTextField";
import { COLORS } from "../../../styles/uiConstants";
import { useClinicTheme } from "../../../theme";

/**
 * Ortak arama kutusu: FormTextField + büyüteç + temizle (×) düğmesi.
 * Kontrollü bileşendir; gecikmeli arama (debounce) çağıranın işidir.
 *
 * @param {string} value
 * @param {(value: string) => void} onChange - metin değeriyle çağrılır
 * @param {string} [placeholder]
 * @param {string} [ariaLabel] - verilmezse placeholder kullanılır
 * @param {boolean} [fullWidth]
 * @param {number} [maxLength]
 * @param {boolean} [isPending] - arama beklenirken (debounce/istek) sağda spinner
 */
export default function SearchField({
  value = "",
  onChange,
  placeholder = "Ara",
  ariaLabel,
  fullWidth = false,
  maxLength = 100,
  isPending = false,
  sx = {},
  ...rest
}) {
  const { palette } = useClinicTheme();
  return (
    <FormTextField
      palette={palette}
      fullWidth={fullWidth}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      inputProps={{ "aria-label": ariaLabel || placeholder, maxLength }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: 18, color: COLORS.slate400 }} />
          </InputAdornment>
        ),
        endAdornment: isPending ? (
          <InputAdornment position="end">
            <CircularProgress size={14} thickness={5} sx={{ color: palette?.primary }} />
          </InputAdornment>
        ) : value ? (
          <InputAdornment position="end">
            <IconButton size="small" aria-label="Aramayı temizle" onClick={() => onChange?.("")}>
              <ClearIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={sx}
      {...rest}
    />
  );
}
